import React, { useEffect, useState } from "react";
import UserAvatar from "../../atoms/ticket-drawer/UserAvatar";

export const MentionList = React.forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selectItem = (index) => {
    const item = props.items?.[index];
    if (item && typeof props.command === 'function') {
      props.command({
        id: item.id,
        label: item.value
      });
    }
  };

  const upHandler = () => {
    if (props.items && props.items.length > 0) {
      setSelectedIndex((prev) => (prev + props.items.length - 1) % props.items.length);
    }
  };

  const downHandler = () => {
    if (props.items && props.items.length > 0) {
      setSelectedIndex((prev) => (prev + 1) % props.items.length);
    }
  };

  const enterHandler = () => {
    if (props.items && props.items.length > 0) {
      selectItem(selectedIndex);
    }
  };

  useEffect(() => {
    if (props.items && props.items.length > 0) {
      setSelectedIndex(0);
    }
  }, [props.items]);

  useEffect(() => {
    if (props.items && props.items.length > 0 && selectedIndex >= props.items.length) {
      setSelectedIndex(0);
    }
  }, [props.items, selectedIndex]);

  React.useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (!props.items || props.items.length === 0) {
        return false;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        downHandler();
        return true;
      }

      if (event.key === 'Enter') {
        event.preventDefault();
        enterHandler();
        return true;
      }

      return false;
    },
  }));

  if (!props.items || props.items.length === 0) {
    return (
      <div className="mention-dropdown z-[1000] bg-white border rounded-[4px] overflow-y-auto border-[#ccc] max-h-[200px]" style={{
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '4px 0',
      }}>
        <div className="mention-item text-gray-500 px-3 py-1">
          No results
        </div>
      </div>
    );
  }

  return (
    <div className="mention-dropdown z-[1000] bg-white border rounded-[4px] overflow-y-auto border-[#ccc] max-h-[200px]" style={{
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      padding: '4px 0',
    }}>
      {props.items.map((item, index) => (
        <div
          className={`flex items-center cursor-pointer rounded-[4px] mention-item ${index === selectedIndex ? 'selected' : ''}`}
          key={`${item.id}-${index}`}
          onClick={() => selectItem(index)}
          style={{
            padding: '8px 12px',
            backgroundColor: index === selectedIndex ? '#f0f0f0' : 'transparent',
            margin: '2px 4px'
          }}
        >
          {item.icon && (
            <UserAvatar
              alt="User"
              classNames="w-6 h-6 rounded-full mr-2"
              fullName={item?.value}
              userId={item?._id}
              src={item?.icon}
              styles={{ objectFit: 'cover' }}
            />
          )}
          <span className="font-14">{item.value}</span>
        </div>
      ))}
    </div>
  );
});